import { render, staticRenderFns } from "./FunilDeVendasConfigCard.vue?vue&type=template&id=48222060&"
import script from "./FunilDeVendasConfigCard.vue?vue&type=script&lang=ts&"
export * from "./FunilDeVendasConfigCard.vue?vue&type=script&lang=ts&"
import style0 from "./FunilDeVendasConfigCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports